import React, { Component } from 'react';
import { InputAdornment } from '@material-ui/core/index';
import { Search } from '@material-ui/icons';
import { arrayOf, func, shape, string } from 'prop-types';
import TimeZoneSearchField from '../TimeZoneSearchField';
import { isEqual } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import { timeZoneType } from '../constants';

import styles from './styles.scss';
import classnames from 'classnames';

const ITEM_NOT_FOUND = {
  name: 'Results not found',
  abbv: '',
  displayOffset: ''
};

export default class FilterableTimeZoneList extends Component {
  static propTypes = {
    timeZones: arrayOf(timeZoneType),
    popularTimeZones: arrayOf(timeZoneType),
    customTimezones: arrayOf(timeZoneType),
    searchFieldPlaceHolder: string,
    popularTimeZonesLabel: string,
    allTimeZonesLabel: string,
    customTimeZoneLabel: string,
    selectedTimeZone: shape({
      name: string,
      timezoneKey: string
    }),
    onSelect: func
  };

  static defaultProps = {
    searchFieldPlaceHolder: 'Search',
    popularTimeZonesLabel: 'US, CANADA, UK',
    allTimeZonesLabel: 'ALL TIME ZONES',
    customTimeZoneLabel: 'CUSTOM TIME ZONES',
    timeZones: [],
    popularTimeZones: [],
    customTimezones: []
  };

  state = {};

  handleSearch = (result, searchValue) => {
    const isSearching = !!searchValue;
    const searchResult =
      result && result.length === 0 && !!searchValue
        ? [ITEM_NOT_FOUND]
        : result;

    this.setState({
      searchResult,
      isSearching
    });
  };

  handleItemSelect = (timezone) => () => {
    const { onSelect } = this.props;

    onSelect && onSelect(timezone);
  };

  drawTimeZoneSearchField() {
    const {
      searchFieldPlaceHolder,
      timeZones,
      customTimezones
    } = this.props;
    const allTimeZones = [
      ...customTimezones,
      ...timeZones
    ];

    return (
      <TimeZoneSearchField
        data={allTimeZones}
        onChange={this.handleSearch}
        searchPlaceHolder={searchFieldPlaceHolder}
        classes={{ searchField: styles.searchField }}
        startAdornment={
          <InputAdornment position='start'>
            <Search className={styles.searchIcon}/>
          </InputAdornment>
        }
      />
    );
  }

  drawListItems(items, filterPopularItems = false) {
    const { selectedTimeZone, popularTimeZones } = this.props;
    const { timezoneKey, name } = selectedTimeZone;

    return items.map((timezone) => {
      const { timezoneKey: itemKey, abbv, name: itemName, displayOffset } = timezone;
      const key = `${timezoneKey}_${itemName}`;
      const isSelected = itemKey === timezoneKey && itemName === name;
      const selected = filterPopularItems
        ? isSelected && !popularTimeZones.find(timezone => timezone.name === itemName)
        : isSelected;
      const displayName = abbv ? `${itemName} - ${abbv}` : `${itemName}`;
      const utcDisplay = displayOffset ? `(UTC${displayOffset})` : '';
      const isItemNotFound = isEqual(timezone, ITEM_NOT_FOUND);

      return (
        <MenuItem
          data-test="timezoneItem"
          data-cy={abbv}
          onClick={this.handleItemSelect(timezone)}
          key={key}
          value={key}
          selected={selected}
          disabled={isItemNotFound}
          className={classnames(styles.listItem, {[styles.capitalizeListItem]: !isItemNotFound})}
        >
          <span className={styles.timeZoneDescription}>{displayName}&nbsp;</span>
          <span className={styles.utcOffset}>{utcDisplay}</span>
        </MenuItem>
      );
    });
  }

  drawGroupedListItems() {
    const {
      allTimeZonesLabel,
      popularTimeZonesLabel,
      popularTimeZones,
      timeZones,
      customTimezones,
      customTimeZoneLabel
    } = this.props;
    const { searchResult } = this.state;
    const displayData = searchResult || timeZones;

    return (
      <div>
        {
          customTimezones.length > 0 &&
          <div>
            <div className={styles.listTitle}><span>{customTimeZoneLabel}</span></div>
            {this.drawListItems(customTimezones)}
          </div>
        }
        {
          popularTimeZones.length > 0 &&
          <div className={styles.listTitle}><span>{popularTimeZonesLabel}</span></div>
        }
        {this.drawListItems(popularTimeZones)}
        <div className={styles.listTitle}><span>{allTimeZonesLabel}</span></div>
        {this.drawListItems(displayData, true)}
      </div>

    );
  }

  render() {
    const { timeZones } = this.props;
    const { searchResult, isSearching } = this.state;
    const displayData = searchResult || timeZones;

    return (
      <div className={styles.filterableTimeZoneList}>
        <div className={styles.searchFieldContainer}>
          {this.drawTimeZoneSearchField()}
        </div>
        <div className={styles.listItemsContainer}>
          {
            isSearching
              ? this.drawListItems(displayData, true)
              : this.drawGroupedListItems()
          }
        </div>
      </div>
    );
  }
}
